import { render, staticRenderFns } from "./creatorTransactionData.vue?vue&type=template&id=4b1d7b3e&"
import script from "./creatorTransactionData.vue?vue&type=script&lang=js&"
export * from "./creatorTransactionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports